import { ICategory, AnswerType } from "../models";

export const round90: ICategory[] = [
	{
		id: "17a00v148yk1v36xtd",
		name: "Beer Countries",
		answers: [
			{
				id: "17a00v148yk1v36xti",
				type: AnswerType.TEXT,
				answer: "Sales of 'craft beer' now out pace sales of 'domestic' beer in this country?",
				answerDe: "Sales of 'craft beer' now out pace sales of 'domestic' beer in this country?",
				question: "What is the United States.",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtn",
				type: AnswerType.TEXT,
				answer:
					"In the capital city of this country you can visit St. James Gate, home of a famous stout and records.",
				answerDe:
					"In the capital city of this country you can visit St. James Gate, home of a famous stout and records.",
				question: "What is Ireland",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xts",
				type: AnswerType.TEXT,
				answer:
					"In this country you will find animals full of hop but not the beer that is marketed to be from here",
				answerDe:
					"In this country you will find animals full of hop but not the beer that is marketed to be from here",
				question: "What is Australia",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtx",
				type: AnswerType.TEXT,
				answer:
					"This country requires brewers to abide by a set of 'purity laws' known as the Reinheitsgebot ",
				answerDe:
					"This country requires brewers to abide by a set of 'purity laws' known as the Reinheitsgebot ",
				question: "What is Germany",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xu2",
				type: AnswerType.TEXT,
				answer: "This European country is home to lambics, trippels and monks! ",
				answerDe: "This European country is home to lambics, trippels and monks! ",
				question: "What is Belguim",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "17a00v148yk1v36xte",
		name: "Beer States",
		answers: [
			{
				id: "17a00v148yk1v36xtj",
				type: AnswerType.TEXT,
				answer:
					"This state is home to nearly a 100 active breweries including the pre-prohibition brewery in the little town of Shiner.",
				answerDe:
					"This state is home to nearly a 100 active breweries including the pre-prohibition brewery in the little town of Shiner.",
				question: "What is Texas",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xto",
				type: AnswerType.TEXT,
				answer: "Visitors to this state can be lost in a 'Purple Haze' of beignets and beads",
				answerDe: "Visitors to this state can be lost in a 'Purple Haze' of beignets and beads",
				question: "What is Louisiana.",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtt",
				type: AnswerType.TEXT,
				answer:
					"You can take part in bike tours to such breweries at Odells and Ft Collins Brewery in this state.",
				answerDe:
					"You can take part in bike tours to such breweries at Odells and Ft Collins Brewery in this state.",
				question: "What is Colorado",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xty",
				type: AnswerType.TEXT,
				answer:
					"A pioneer of the craft scene, use the PCH to explore this states brews and scenic views.",
				answerDe:
					"A pioneer of the craft scene, use the PCH to explore this states brews and scenic views.",
				question: "What is California.",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xu3",
				type: AnswerType.TEXT,
				answer:
					"This state also known for Pinot Noir and cherries, has people going 'full sail' to try the areas' hop heavy beers.",
				answerDe:
					"This state also known for Pinot Noir and cherries, has people going 'full sail' to try the areas' hop heavy beers.",
				question: "What is Oregon",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "17a00v148yk1v36xtf",
		name: "Beer Styles",
		answers: [
			{
				id: "17a00v148yk1v36xtk",
				type: AnswerType.TEXT,
				answer: "All beer can be categorized into two types of beer",
				answerDe: "All beer can be categorized into two types of beer",
				question: "What are Ales and Lagers",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtp",
				type: AnswerType.TEXT,
				answer:
					"The style was said to have been created to survive the long ship voyages around the British Empire",
				answerDe:
					"The style was said to have been created to survive the long ship voyages around the British Empire",
				question: "What are IPAs.",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtu",
				type: AnswerType.TEXT,
				answer:
					"This style, popular on St Patricks Day, often uses nitrogen instead of carbon dioxide to create a smooth creamy texture to offset its coffee-like bitterness",
				answerDe:
					"This style, popular on St Patricks Day, often uses nitrogen instead of carbon dioxide to create a smooth creamy texture to offset its coffee-like bitterness",
				question: "What is an Irish Stout",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtz",
				type: AnswerType.TEXT,
				answer:
					"The style, popular with mass-produced beer was first created in the Czech Republic town of Pilsen. ",
				answerDe:
					"The style, popular with mass-produced beer was first created in the Czech Republic town of Pilsen. ",
				question: "What is a Pilsner.",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xu4",
				type: AnswerType.TEXT,
				answer: "this fruit beer originating in Belgium can either be sweet or sour.",
				answerDe: "this fruit beer originating in Belgium can either be sweet or sour.",
				question: "What is a lambic",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "17a00v148yk1v36xtg",
		name: "Beer Slogans",
		answers: [
			{
				id: "17a00v148yk1v36xtl",
				type: AnswerType.TEXT,
				answer: "I don't always drink beer but when I do..",
				answerDe: "I don't always drink beer but when I do..",
				question: "What is Dos Equis",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtq",
				type: AnswerType.TEXT,
				answer: "It's Australian for beer",
				answerDe: "It's Australian for beer",
				question: "What is Fosters",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtv",
				type: AnswerType.TEXT,
				answer: "Taste Great! Less Filing!",
				answerDe: "Taste Great! Less Filing!",
				question: "What is Miller Lite",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xu0",
				type: AnswerType.TEXT,
				answer: "Off centered ales for off centered people",
				answerDe: "Off centered ales for off centered people",
				question: "What is Dogfish Head",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xu5",
				type: AnswerType.TEXT,
				answer: "This Texas claims their blonde ale 'Goes Down Easy'",
				answerDe: "This Texas claims their blonde ale 'Goes Down Easy'",
				question: "What is Deep Ellum",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "17a00v148yk1v36xth",
		name: "Potent Potables",
		answers: [
			{
				id: "17a00v148yk1v36xtm",
				type: AnswerType.TEXT,
				answer: "Temptress, Rock Ryder, Punkel",
				answerDe: "Temptress, Rock Ryder, Punkel",
				question: "What is Lakewood",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtr",
				type: AnswerType.TEXT,
				answer: "Lawnmower, Elissa, Spring Bock",
				answerDe: "Lawnmower, Elissa, Spring Bock",
				question: "What is St. Arnold",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xtw",
				type: AnswerType.TEXT,
				answer: "Great Scot!, Velvet Hammer, Wintervention",
				answerDe: "Great Scot!, Velvet Hammer, Wintervention",
				question: "What is Peticolas",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xu1",
				type: AnswerType.TEXT,
				answer: "Atrial Rubicite, Wytchmaker, Le Petite Prince",
				answerDe: "Atrial Rubicite, Wytchmaker, Le Petite Prince",
				question: "What is Jester King",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "17a00v148yk1v36xu6",
				type: AnswerType.TEXT,
				answer: "Sculpin, Victory at sea, Dorado",
				answerDe: "Sculpin, Victory at sea, Dorado",
				question: "What is Ballast Point",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	}
];
